module.exports = __webpack_public_path__ + "static/ch-7-illustration-mlk-stage@2x-9df3366e6dc3bbe2208875e551dde3fb.png";